module.exports = __webpack_public_path__ + "img/snowman-head.c1a657f6.svg";